import { render, staticRenderFns } from "./ApplicationSingle.vue?vue&type=template&id=b452f5fc&scoped=true&"
import script from "./ApplicationSingle.vue?vue&type=script&lang=js&"
export * from "./ApplicationSingle.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSingle.vue?vue&type=style&index=0&id=b452f5fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452f5fc",
  null
  
)

export default component.exports